export default "__VITE_ASSET__3e595fb8__"